import { useMutation } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export function useLog() {
  return useMutation(trpcOptions.app.log.mutationOptions())
}
